var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScannerIcons(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.022,
    height: 29.165,
    viewBox: "0 0 32.022 29.165",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun_barcode_scanner_918500",
    "data-name": "noun_barcode scanner_918500",
    transform: "translate(-14.9 -17.7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_74",
    "data-name": "Group 74",
    transform: "translate(14.9 17.7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_369",
    "data-name": "Path 369",
    d: "M18.516,27.3a.945.945,0,0,0,.916-.916V20.4a.841.841,0,0,1,.809-.863h6.469a.916.916,0,0,0,0-1.833H20.242A2.646,2.646,0,0,0,17.6,20.342v6.038A.909.909,0,0,0,18.516,27.3Z",
    transform: "translate(-16.144 -17.7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_370",
    "data-name": "Path 370",
    d: "M18.516,55.2a.945.945,0,0,0-.916.916v5.391a2.646,2.646,0,0,0,2.642,2.642h6.469a.916.916,0,0,0,0-1.833H20.242a.794.794,0,0,1-.809-.809V56.116A.985.985,0,0,0,18.516,55.2Z",
    transform: "translate(-16.144 -34.984)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_371",
    "data-name": "Path 371",
    d: "M62.395,54.6a.945.945,0,0,0-.916.916v5.714a.808.808,0,0,1-.863.809h-6.2a.916.916,0,1,0,0,1.833h6.2a2.646,2.646,0,0,0,2.642-2.642V55.516A.864.864,0,0,0,62.395,54.6Z",
    transform: "translate(-32.691 -34.708)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_372",
    "data-name": "Path 372",
    d: "M62.395,27.342a.945.945,0,0,0,.916-.916V20.442A2.646,2.646,0,0,0,60.67,17.8H54.416a.916.916,0,1,0,0,1.833h6.2a.841.841,0,0,1,.863.809v6.038A.937.937,0,0,0,62.395,27.342Z",
    transform: "translate(-32.691 -17.746)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_373",
    "data-name": "Path 373",
    d: "M46.922,43.371A1.68,1.68,0,0,0,45.251,41.7H16.571a1.671,1.671,0,1,0,0,3.342H45.251A1.68,1.68,0,0,0,46.922,43.371Z",
    transform: "translate(-14.9 -28.762)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScannerIcons);
export default __webpack_public_path__ + "static/media/scannerIcons.65c2460b.svg";
export { ForwardRef as ReactComponent };